/* Ingredient Videos — click-to-play facade.
   Each card shows a poster + custom play button; the real <video>/<iframe>
   lives in an inert <template> and is only inserted (and played) on click, so
   nothing downloads until the visitor asks for it. Runs regardless of
   prefers-reduced-motion (it is functional, not decorative). */
(() => {
  if (window.__ivVideoInit) return;
  window.__ivVideoInit = true;

  function play(button) {
    const media = button.closest('.iv-card__media');
    if (!media) return;
    const tpl = media.querySelector('template');
    if (!tpl) return;

    media.replaceChildren(tpl.content.cloneNode(true));

    const embed = media.querySelector('video, iframe');
    if (!embed) return;
    if (embed.tagName === 'VIDEO') {
      // Unmute explicitly: the click is a user gesture, so sound is allowed
      // (the autoplay attribute is intentionally not used, since that triggers
      // the browser's muted-autoplay fallback).
      embed.muted = false;
      if (typeof embed.play === 'function') {
        const p = embed.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }
    }
    // Move focus to the player so keyboard users land on the controls.
    if (typeof embed.focus === 'function') {
      embed.focus({ preventScroll: true });
    }
  }

  function bind(scope) {
    scope.querySelectorAll('.iv-play').forEach((button) => {
      if (button.dataset.ivBound) return;
      button.dataset.ivBound = '1';
      button.addEventListener('click', () => play(button));
    });
  }

  const run = () => bind(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  // Shopify theme editor: re-bind a section after it is re-rendered.
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
